"use client";
import React from "react";
import { motion } from "motion/react";

interface Props {
  className?: string;
  header?: string;
  headerColor?: string;
  textColor?: string;
  children: React.ReactNode;
}

const Descriptor = ({
  className = "",
  header = "",
  headerColor = "--foreground",
  children,
  textColor = "--foreground",
}: Props) => {
  return (
    <motion.div
      initial={{ scaleX: 0 }}
      whileInView={{ scaleX: 1, transition: { type: "spring", duration: 0.5 } }}
      viewport={{ once: true, amount: 1 }}
      className={className + " mx-[4%] p-10 flex flex-col items-center"}
    >
      {header != "" && (
        <div>
          <h1 className={`text-5xl text-(${headerColor})`}>{header}</h1>
          <motion.div
            initial={{ scaleX: 0 }}
            whileInView={{
              scaleX: 1,
              transition: { duration: 0.7, delay: 0.4 },
            }}
            viewport={{ once: true }}
            className="bg-(--uforeground2) items-center w-auto h-[3px] "
            style={{ transformOrigin: "center" }}
          />
        </div>
      )}
      <div className={`w-full text-(${textColor})`}>{children}</div>
    </motion.div>
  );
};

export default Descriptor;
